import HTTPRetryUtil from 'src/utils/httpretry';
import { mergeDashboardFiltersWithBotanicQuery } from 'src/utils/query';
import ChartUtils from 'src/utils/chart';
import dayjs from 'dayjs';
import path from 'path';
export const fetchDataQueryList = async ({ base_list, query_list, chrysalisRef, topicId, projectId, chrysalisURL, limit, baselineListOperation, queryListOperation, sortField, sortAsc, minConceptFreq }) => {
    const chrysalisPath = path.join(chrysalisRef, '_topics', `${topicId}`, '_diff_queries_list/');
    return await HTTPRetryUtil.post(`projects/${projectId}/tunnel${chrysalisPath}`, {
        body: {
            query_baseline_list: base_list,
            query_list: query_list,
            limit,
            baseline_list_operation: baselineListOperation,
            list_operation: queryListOperation,
            sort_field: sortField,
            sort_asc: sortAsc,
            min_concept_freq: minConceptFreq
        },
        config: {
            params: {
                chrysalis_url: chrysalisURL,
                invalidate_cache: false,
                topicId: topicId,
                chrysalisRef: chrysalisRef,
                allow_read_cache: true,
            }
        },
    });
};
export const splitQuery = (query, startDate, endDate, dateField) => {
    const filter1 = [{
            field: dateField,
            op: '<',
            value: startDate,
        }];
    const filter2 = [{
            field: dateField,
            op: '>=',
            value: startDate,
        }, {
            field: dateField,
            op: '<=',
            value: endDate,
        }];
    return query.reduce((acc, query) => {
        const copyQuery = () => JSON.parse(JSON.stringify(query));
        return [
            // pass all queries with filter1 applied
            [...acc[0], mergeDashboardFiltersWithBotanicQuery(copyQuery(), filter1)],
            // pass all queries with filter2 applied
            [...acc[1], mergeDashboardFiltersWithBotanicQuery(copyQuery(), filter2)],
        ];
    }, [[], []]);
};
export const getMaxDiff = (concepts, key) => {
    return Math.max(...concepts.map((c) => Math.abs(c[key])));
};
export const getDataRows = (concepts, sortSelection, displayKey) => {
    const maxDiff = getMaxDiff(concepts, sortSelection);
    return concepts.map((concept) => {
        const columns = [{
                label: concept.freq_diff.toString(),
                value: concept.freq_diff,
            }];
        displayKey === 'freq_diff_fraction' && columns.push({
            label: ChartUtils.formatPercent(concept.freq_diff_fraction * 100),
            value: concept.freq_diff_fraction,
        });
        displayKey === 'reldiff' && columns.push({
            label: ChartUtils.formatPercent(concept.reldiff * 100),
            value: concept.reldiff,
        });
        return {
            bars: [{ percent: (Math.abs(concept[sortSelection]) / maxDiff) * Math.sign(concept[sortSelection]) }],
            label: concept.concept_name,
            columns,
        };
    });
};
export const getDateRange = (fromSelection, customDateRange) => {
    if (fromSelection === 'Custom') {
        return [
            dayjs(customDateRange[0], 'DD/MM/YYYY').format('YYYY-MM-DDT00:00:00'),
            dayjs(customDateRange[1], 'DD/MM/YYYY').format('YYYY-MM-DDT00:00:00'),
        ];
    }
    const days = parseInt(fromSelection.match(/\d+/)?.[0] ?? '0');
    return [
        dayjs().subtract(days, 'days').startOf('day').format('YYYY-MM-DDT00:00:00'),
        dayjs().format('YYYY-MM-DDT00:00:00'),
    ];
};
export const generateCSV = (conceptList, displaySelection) => {
    return conceptList.map((concept) => {
        const data = {
            'Concept': concept.concept_name,
            'Freq (#) change': concept.freq_diff,
        };
        if (displaySelection === 'Frequency change') {
            data['Freq (%) change'] = ChartUtils.formatPercent(concept.freq_diff_fraction * 100);
        }
        if (displaySelection === 'Relative difference') {
            data['Relative diff'] = ChartUtils.formatPercent(concept.reldiff * 100);
        }
        return data;
    });
};
